import { SET_PENSIONIERUNG_DATA } from "../constants/actions";
import { FinanceBoxProps } from "../types";
import { privateApi as API } from "../utils/api";
import refreshToken from "./refreshToken";

export type PensionierungData = {
  title: string;
  text: string;
  retirementBox: {
    amount: number;
    subTitle: string;
    projectedGraph: {
      date: string;
      year: number;
      age: number;
      value: number;
    }[];
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  actionsBox: {
    title: string;
    text: string;
    isVisible: boolean;
    actionList: {
      title: string;
      text: string;
      link: string;
      linkText: string;
    }[];
  };
  simulationBox: {
    title: string;
    toolTip: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  financeExpertBox: FinanceBoxProps;
  purchaseLinkBox: {
    title: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  contactBox: {
    title: string;
    text: string;
    link: string;
    linkText: string;
    isVisible: boolean;
  };
  retirementPageContentBox: {
    content: string;
  };
};

export const getPensionierungData = (payload) => {
  const token = localStorage.getItem("ip_access_token");
  return async function (dispatch) {
    try {
      const response: { data: { data: PensionierungData } } = await API.get(
        "pages/retirement"
      );
      dispatch({
        type: SET_PENSIONIERUNG_DATA,
        payload: response.data.data,
      });
      await refreshToken(null);
      return response;
    } catch (err) {
      return err;
    }
  };
};
